import moment from 'moment'

export default {
  data () {
    return {
      isModalOpen: false
    }
  },
  methods: {
    // Checks if it's within contact daytime. If not, promps alert to user.
    async checkContactTimezone (params, makeCall, onCancelCall = null) {
      // if the modal is already open, we skip the next steps
      if (this.isModalOpen) {
        return
      }

      let { timezone, name, phoneNumber } = params
      const openTime = params.calls_notifications_open_time || '08:00'
      const closeTime = params.calls_notifications_close_time || '18:00'

      // When the contact has no timezone on record, infer one from the phone
      // number's area code so calling-hour restrictions still apply. If it
      // can't be mapped (VoIP / international), inference returns null and we
      // fall through to the call without blocking it.
      if (!timezone && phoneNumber) {
        const fixed = this.$options.filters.fixPhone(phoneNumber)

        if (fixed) {
          try {
            const parsed = window.phoneUtil.parse(fixed)

            if (window.phoneUtil.isValidNumber(parsed)) {
              const meta = await this.$axios.get('/api/v1/phone-number/lookup', {
                params: { phone_number: fixed }
              }).then(res => res.data).catch(err => {
                console.error('Phone number lookup failed', err?.response?.data || err)
                return null
              })

              timezone = meta?.timezone || null
            }
          } catch (e) {
            // invalid number — leave timezone null and fall through to the call
          }
        }
      }

      // check contact has timezone or not
      if (timezone) {
        const contactLocalTime = moment().tz(timezone)
        const startDay = moment.tz(
          `${contactLocalTime.format('YYYY-MM-DD')} ${openTime}`,
          'YYYY-MM-DD HH:mm',
          timezone
        )
        const endDay = moment.tz(
          `${contactLocalTime.format('YYYY-MM-DD')} ${closeTime}`,
          'YYYY-MM-DD HH:mm',
          timezone
        )

        if (!contactLocalTime.isBetween(startDay, endDay)) {
          this.isModalOpen = true

          const hasName = name && name !== 'No Name'
          const formattedNumber = phoneNumber
            ? this.$options.filters.fixPhone(phoneNumber, '', false, false, true)
            : ''
          const label = hasName ? name : (formattedNumber || '')
          const suffix = label ? ` for ${label}` : ' at their location'

          return this.$bvModal.msgBoxConfirm(
            `This is outside the contact's day time. Do you want to make a call? It's ${contactLocalTime.format(
              'hh:mm A'
            )}${suffix}.`,
            {
              buttonSize: 'sm',
              okTitle: 'OK',
              cancelTitle: 'Cancel',
              id: 'daytime-hours-confirmation',
              centered: true
            }
          ).then(confirm => {
            this.isModalOpen = false
            if (confirm) {
              makeCall()
              return
            }

            // if the user clicks on cancel and there's a callback, we call it to execute an action
            if (onCancelCall) {
              onCancelCall()
            }
          }).catch(() => {
            this.isModalOpen = false
            if (onCancelCall) {
              onCancelCall()
            }
          })
        }
      }

      makeCall()
    }
  }
}
